const map = {
	"./arangoCollectionModel": 29736,
	"./arangoCollectionModel.js": 29736,
	"./arangoDatabase": 52168,
	"./arangoDatabase.js": 52168,
	"./arangoDocument": 98872,
	"./arangoDocument.js": 98872,
	"./arangoReplication": 30591,
	"./arangoReplication.js": 30591,
	"./arangoSession": 61549,
	"./arangoSession.js": 61549,
	"./arangoStatistics": 7074,
	"./arangoStatistics.js": 7074,
	"./arangoStatisticsDescription": 37502,
	"./arangoStatisticsDescription.js": 37502,
	"./arangoUsers": 77089,
	"./arangoUsers.js": 77089,
	"./clusterCoordinator": 6087,
	"./clusterCoordinator.js": 6087,
	"./clusterServer": 23278,
	"./clusterServer.js": 23278,
	"./coordinator": 67113,
	"./coordinator.js": 67113,
	"./currentDatabase": 29311,
	"./currentDatabase.js": 29311,
	"./foxx": 63796,
	"./foxx.js": 63796,
	"./foxxRepoModel": 48691,
	"./foxxRepoModel.js": 48691,
	"./graph": 24707,
	"./graph.js": 24707,
	"./metricModel": 75114,
	"./metricModel.js": 75114,
	"./newArangoLog": 34953,
	"./newArangoLog.js": 34953,
	"./notification": 7116,
	"./notification.js": 7116,
	"./userConfig": 16578,
	"./userConfig.js": 16578
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82059;